module.exports = __webpack_public_path__ + "img/slphouse_main13.9c097096.png";